import { useState, useEffect } from "react";
import { buscarEmpreendimentosComCidadeService } from "../../../services/buscarEmpreendimentosComCidadeService";
// Importe o serviço correto para buscar empreendimentos
// import { empreendimentoService } from 'caminho/do/seu/service';

interface UseEmpreendimentosResult {
  isLoading: boolean;
  empreendimentos: any[];
}

const useEmpreendimentos = (fetch: boolean, estadoId?: number): UseEmpreendimentosResult => {
  const [isLoading, setIsLoading] = useState(true);
  const [empreendimentos, setEmpreendimentos] = useState<any[]>([]);

  useEffect(() => {
    const fetchEmpreendimentos = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await buscarEmpreendimentosComCidadeService();
          if (data) {
            setEmpreendimentos(data);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar empreendimentos:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
  return { isLoading, empreendimentos };
    };

    fetchEmpreendimentos();
  }, [estadoId, fetch]);

  return { isLoading, empreendimentos };
};

export default useEmpreendimentos;